import { Reveal, MaskLineInView } from "./Reveal";
import { MapPin, Clock, Phone, Navigation, HeartHandshake, Music, BookOpen } from "lucide-react";

const ADDRESS = "411 Fargo Ave, San Antonio, TX 78220";
const MAPS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}`;

const expect = [
  { icon: HeartHandshake, text: "A warm apostolic family — come as you are, no dress code, no pressure" },
  { icon: Music, text: "Spirit-filled worship, anointed music and heartfelt praise" },
  { icon: BookOpen, text: "A clear, Bible-based message and personal prayer if you want it" },
];

export default function PlanVisit() {
  return (
    <section id="visit" className="relative py-28 md:py-40 bg-[#0A0710]">
      <div className="absolute -left-32 top-24 w-[480px] h-[380px] rounded-full bg-[#D4AF37]/8 blur-[140px]" />
      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal><span className="section-label">Plan Your Sunday Visit</span></Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] mt-5 text-white">
            <MaskLineInView>Your seat is</MaskLineInView>
            <MaskLineInView delay={0.1}><span className="italic text-gold">already saved.</span></MaskLineInView>
          </h2>
          <Reveal delay={0.2}>
            <p className="text-lg text-[#B4ADC1] font-light mt-6 leading-relaxed">
              Whether it's your first time in church or your first time back in years — Sunday at F.O.L.W.A.C. was made for you. Here's what to expect:
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <ul className="mt-8 space-y-4">
              {expect.map(({ icon: Icon, text }) => (
                <li key={text} className="flex items-start gap-4 text-sm text-[#C9C3D4] font-light leading-relaxed">
                  <Icon className="w-5 h-5 text-gold shrink-0 mt-0.5" strokeWidth={1.4} />
                  {text}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="glass rounded-3xl p-8 sm:p-10" data-testid="plan-visit-card">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-gold" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[#7A708A]">Sunday Worship</p>
                  <p className="text-white text-lg font-display mt-1" data-testid="visit-time">Sundays · 12:00 Noon CST</p>
                  <p className="text-xs text-[#B4ADC1] font-light mt-1">Come to the Water — everyone welcome</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-gold" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[#7A708A]">Location</p>
                  <p className="text-white text-lg font-display mt-1" data-testid="visit-address">411 Fargo Ave</p>
                  <p className="text-xs text-[#B4ADC1] font-light mt-1">San Antonio, TX 78220 · East Side</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-gold" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[#7A708A]">Call or Text</p>
                  <a href="tel:+17262475926" className="text-white text-lg font-display mt-1 block hover:text-gold transition-colors" data-testid="visit-phone">726-247-5926</a>
                  <p className="text-xs text-[#B4ADC1] font-light mt-1">Need a ride? Ask about transportation</p>
                </div>
              </div>
            </div>

            <a
              href={MAPS_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-8 w-full py-4 rounded-full bg-gold text-black font-medium hover:bg-[#e6c14e] transition-colors flex items-center justify-center gap-2"
              data-testid="visit-directions-btn"
            >
              <Navigation className="w-4 h-4" /> Get Directions
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
